export default defineNuxtPlugin(() => {
  const cart = useCartStore();
  // Async layouts can still be hydrating when app:mounted fires.
  onNuxtReady(() => {
    try {
      const saved: unknown = JSON.parse(sessionStorage.getItem('videosurv-cart') || '[]');
      if (Array.isArray(saved)) {
        for (const item of saved.slice(0, 100)) {
          const product = item?.product;
          if (
            product &&
            Number.isInteger(product.id) &&
            typeof product.title === 'string' &&
            typeof product.slug === 'string' &&
            typeof product.image_url === 'string' &&
            typeof product.category?.route === 'string' &&
            typeof product.category?.title === 'string' &&
            typeof product.price === 'number' &&
            Number.isFinite(item.quantity)
          )
            cart.add(product, item.quantity);
        }
      }
    } catch {
      /* A blocked or invalid local cache never prevents shopping. */
    }
    cart.$subscribe((_mutation, state) => {
      try {
        sessionStorage.setItem('videosurv-cart', JSON.stringify(state.products));
      } catch {
        /* The current in-memory cart still works. */
      }
    });
  });
});
